/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

// @ts-ignore Allow unused imports
import type * as Types from '../../../graphql/schema';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ClientActivityCsvExportQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ClientActivityCsvExportQuery = { __typename: 'Query', clientActivityCsvExport: { __typename: 'CsvExport', status: Types.CsvExportStatus, id: string } | null };


export const ClientActivityCsvExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientActivityCsvExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientActivityCsvExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ClientActivityCsvExportQuery, ClientActivityCsvExportQueryVariables>;